<template>
  <div class="container">
    <div class="icons">
      <router-link
        tag="div"
        class="icon"
        :class="icon.id === '2' ? 'between' : ''"
        :to="{ path: './' + $route.params.content, query: { ps: icon.name } }"
        v-for="icon in icons"
        :key="icon.id"
      >
        <img
          v-if="icon.id === '1'"
          class="on"
          src="../../assets/img/icon_1_on.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '1'"
          class="off"
          src="../../assets/img/icon_1_off.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '2'"
          class="on"
          src="../../assets/img/icon_2_on.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '2'"
          class="off"
          src="../../assets/img/icon_2_off.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '3'"
          class="on"
          src="../../assets/img/icon_3_on.svg"
          alt="Icon 3"
        />
        <img
          v-if="icon.id === '3'"
          class="off"
          src="../../assets/img/icon_3_off.svg"
          alt="Icon 3"
        />
        <span>{{ icon.title }}</span>
      </router-link>
    </div>
    <div
      class="focus"
      v-for="(iconArrow, index) in iconArrows"
      :key="index"
      :style="
        'top:' +
          (iconArrow.y + iconArrow.height) +
          'px; ' +
          'left:' +
          (iconArrow.x + iconArrow.width / 2) +
          'px'
      "
    >
      <i class="material-icons" :class="isArrowAnimation ? 'arrow' : ''"
        >arrow_upward</i
      >
    </div>
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div class="content-container">
          <div
            class="img"
            :style="{ backgroundImage: 'url(' + imgUrl + ')' }"
          ></div>
          <div class="content-description" v-html="contentDescription()"></div>
        </div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from "../LovalFooter";
export default {
  components: {
    LovalFooter
  },
  props: ["content", "icons", "links"],
  data() {
    return {
      iconArrows: [],
      isArrowAnimation: false
    };
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.setIconArrows);
      //Init
      if (this.$store.state.arrowAnimation) {
        this.setIconArrows();
        this.arrowAnimation();
      }
    });
  },
  computed: {
    imgUrl() {
      return require("../../assets/img/" + this.content.image);
    }
  },
  methods: {
    setIconArrows() {
      this.iconArrows = [];
      let iconArrows = document.querySelectorAll(".icons div");
      iconArrows.forEach(iconArrow =>
        this.iconArrows.push(iconArrow.getBoundingClientRect())
      );
    },
    arrowAnimation() {
      setTimeout(() => (this.isArrowAnimation = true), 2000);
    },
    contentDescription() {
      let link = "<a href='" + this.$route.params.content + "'>link</a>";
      link = "";
      return this.content.description + link;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
}
.focus {
  position: fixed;
  transform: translateX(-50%);
  & i {
    transform: translateY(500px);
    visibility: hidden;
    font-size: 48px;
    color: var(--yellow);
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
  & i.arrow {
    transform: translateY(0px);
    visibility: visible;
    transition: all 0.8s cubic-bezier(0.18, 0.89, 0.32, 1.28) 2s;
  }
}
</style>
